/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	Faculty,
	FacultyFromJSON,
	FacultyFromJSONTyped,
	FacultyToJSON,
} from "./Faculty";

/**
 *
 * @export
 * @interface FacultyContactInformation
 */
export interface FacultyContactInformation {
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformation
	 */
	id?: string;
	/**
	 *
	 * @type {Date}
	 * @memberof FacultyContactInformation
	 */
	createdAt?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof FacultyContactInformation
	 */
	updatedAt?: Date;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformation
	 */
	facultyId?: string;
	/**
	 *
	 * @type {Faculty}
	 * @memberof FacultyContactInformation
	 */
	faculty?: Faculty;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformation
	 */
	contactPersonName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformation
	 */
	email?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformation
	 */
	phone?: string | null;
}

export function FacultyContactInformationFromJSON(
	json: any
): FacultyContactInformation {
	return FacultyContactInformationFromJSONTyped(json, false);
}

export function FacultyContactInformationFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): FacultyContactInformation {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		createdAt: !exists(json, "createdAt")
			? undefined
			: new Date(json["createdAt"]),
		updatedAt: !exists(json, "updatedAt")
			? undefined
			: new Date(json["updatedAt"]),
		facultyId: !exists(json, "facultyId") ? undefined : json["facultyId"],
		faculty: !exists(json, "faculty")
			? undefined
			: FacultyFromJSON(json["faculty"]),
		contactPersonName: !exists(json, "contactPersonName")
			? undefined
			: json["contactPersonName"],
		email: !exists(json, "email") ? undefined : json["email"],
		phone: !exists(json, "phone") ? undefined : json["phone"],
	};
}

export function FacultyContactInformationToJSON(
	value?: FacultyContactInformation | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		createdAt:
			value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
		updatedAt:
			value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
		facultyId: value.facultyId,
		faculty: FacultyToJSON(value.faculty),
		contactPersonName: value.contactPersonName,
		email: value.email,
		phone: value.phone,
	};
}
